{
    function setFontSize(quote: HTMLElement) {
        const quoteText = quote.querySelector(".bux-quote__text");

        if (!(quoteText instanceof HTMLElement)) {
            console.warn('Buckeye UX Quote component is unable to find a quote text HTMLElement.')
            return;
        }

        const quoteTextLength = quoteText.textContent.trim().length;

        if (quoteTextLength >= 150) {
            const quoteAuthor = quote.querySelector(".bux-quote__author");
            const quoteSource = quote.querySelector(".bux-quote__source");

            quoteText.style.fontSize = "1.125rem";
            quoteText.style.lineHeight = "1.75rem";
            if (quoteAuthor instanceof HTMLElement) {
                quoteAuthor.style.fontSize = "1rem";
            }
            if (quoteSource instanceof HTMLElement) {
                quoteSource.style.fontSize = "1rem";
            }
        }
    }

    const init = () => {
        const quotes = document.querySelectorAll(".bux-quote");

        for (const quote of quotes) {
            if (quote instanceof HTMLElement) {
                setFontSize(quote);
            }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
}
